
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"56","height":"56"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M48.444 55.99H7.56c-3.1 0-5.486-1.089-6.708-3.067s-1.128-4.592.261-7.365L21.87 4.091C23.502 1.453 25.675 0 28.002 0s4.5 1.453 6.136 4.091l20.753 41.467c1.385 2.774 1.475 5.391.252 7.368s-3.601 3.064-6.699 3.064zM28.002 42.168a3.791 3.791 0 103.79 3.792 3.8 3.8 0 00-3.79-3.792zm0-28.6a3.8 3.8 0 00-3.8 3.795v17.164a3.792 3.792 0 107.583 0V17.363a3.8 3.8 0 00-3.783-3.792z","fill":"#222"}})])
          )
        }
      }
    